import { render, staticRenderFns } from "./AgreementManager.vue?vue&type=template&id=2907fcfe&scoped=true"
import script from "./AgreementManager.vue?vue&type=script&lang=js"
export * from "./AgreementManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2907fcfe",
  null
  
)

export default component.exports